// Loudspeaker (shared/loudspeaker.ts): the megaphone toggle on World's chat box and the banner a shout
// puts across the top of every screen for everyone online.
import type { Broadcast } from '../shared/protocol.ts';
import { LOUD } from '../shared/loudspeaker.ts';
import { esc } from './fmt.ts';
import { chatShown } from './chatfilter.ts';
import { playerLink } from './social.ts';

let on = false;
export const loudOn = () => on;
export const setLoud = (v: boolean) => { on = v; };
export const LOUD_PRICE = `${LOUD.cost / 1_000_000}M`;
export const loudPlaceholder = () => `Shout · ${LOUD_PRICE} coins`;

const MEGAPHONE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"><path d="M3 10v4h3l8 5V5L6 10z"/><path d="M17.5 9a4 4 0 0 1 0 6M6 14l1.5 5h2.5l-1.2-4"/></svg>';
export const loudButton = () => `<button type="button" class="loud-btn${on ? ' on' : ''}" data-act="loud-toggle" aria-pressed="${on}" title="Loudspeaker: ${LOUD_PRICE} coins, one line to everyone online" aria-label="Loudspeaker">${MEGAPHONE}</button>`;

/** "/loud text" (or /shout) typed in any chat box. */
export function loudCommand(text: string): string | null {
  const m = text.match(/^\/(?:loud|shout)\s+([\s\S]+)$/i);
  return m ? m[1].trim() : null;
}

let timer = 0;
/** A shout arrived: show it across the top for LOUD.showMs. A newer shout replaces the one showing. */
export function showLoud(b: Broadcast) {
  let bar = document.getElementById('loudbar');
  if (!bar) { bar = document.createElement('div'); bar.id = 'loudbar'; bar.className = 'loud-bar'; bar.setAttribute('role', 'status'); document.body.append(bar); }
  bar.innerHTML = `${MEGAPHONE}<b>${b.who ? playerLink(b.who) : ''}</b><span>${esc(chatShown(b.text))}</span>`;
  bar.hidden = false;
  clearTimeout(timer);
  timer = window.setTimeout(() => { bar!.hidden = true; }, LOUD.showMs);
}
